import { render, staticRenderFns } from "./pos-search-ticket-modal.vue?vue&type=template&id=dc8a348e&scoped=true&"
import script from "./pos-search-ticket-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-search-ticket-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8a348e",
  null
  
)

export default component.exports